import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import CollectionList from '../../Collection/CollectionList'
import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import CollectionItem from '../../Collection/CollectionItem'
import {
  fetchTrainers,
  selectTrainers,
} from '../../../reducers/Organisation/organisationStaffReducer'
import { fetchTrainingTypes } from '../../../reducers/trainingsReducer'

export class OrganisationStaffList extends Component {
  static propTypes = {
    trainers: PropTypes.array.isRequired,
    fetchTrainers: PropTypes.func.isRequired,
    fetchTrainingTypes: PropTypes.func.isRequired,
    searchQuery: PropTypes.string,
    onlyActive: PropTypes.bool,
  }

  static defaultProps = {
    trainers: [],
  }

  componentDidMount() {
    this.props.fetchTrainers()
    this.props.fetchTrainingTypes()
  }

  render() {
    let { trainers, searchQuery, onlyActive } = this.props

    if (searchQuery !== '') {
      trainers = trainers.filter((trainer) => {
        const userName = `${trainer.user.firstName} ${trainer.user.lastName}`
        return (
          userName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          trainer.user.email.toLowerCase().includes(searchQuery.toLowerCase())
        )
      })
    }

    if (onlyActive) {
      trainers = trainers.filter((trainer) => {
        return trainer.user.isActive === true
      })
    }

    return (
      <CollectionList>
        {typeof trainers !== 'undefined' &&
          trainers.map((trainer) => {
            return (
              <Link key={trainer.id} to={`/dashboard/organisation/staff/legacy/${trainer.id}`}>
                <CollectionItem rounded mark>
                  <Avatar size="big">
                    <img
                      src={getAssetLink({
                        path: 'chitown-avatar/avatar',
                        file: trainer.user.avatar,
                      })}
                      alt={''}
                    />
                  </Avatar>
                  <strong>
                    {trainer.user.firstName} {trainer.user.lastName}
                  </strong>
                  <span>{trainer.phone}</span>
                  <span>{trainer.user.email}</span>
                </CollectionItem>
              </Link>
            )
          })}
      </CollectionList>
    )
  }
}

export default connect(
  (state) => ({
    trainers: selectTrainers(state),
  }),
  { fetchTrainers, fetchTrainingTypes },
)(OrganisationStaffList)
